/**
 * Is this pathname one of the web2app funnel's entries?
 *
 *   /funnel            referral landing → redirects into /funnel-auth
 *   /funnel-auth       the funnel (also the Google OAuth landing)
 *   /funnel-auth/intro the intro entry (explainer slides first)
 *   /funnel-intro      the intro entry's own path
 *   /funnel-2          the intro entry's former name → redirects to /funnel-intro
 *
 * Matching is by prefix on a normalised path (lower-cased, trailing slashes
 * dropped), so `/funnel-auth/` or `/Funnel-Auth` from an ad link count too.
 * Every rule that exempts "the funnel" from site-wide chrome or takeovers —
 * the navbar, the onboarding modal, the make.pixleyai.com welcome — goes
 * through here so the entries can never drift apart again.
 */
export const isFunnelPath = (pathname) => {
  if (typeof pathname !== 'string') return false;
  const p = pathname.toLowerCase().replace(/\/+$/, '') || '/';
  return p === '/funnel' || p.startsWith('/funnel-');
};

export default isFunnelPath;
